export default "__VITE_ASSET__BRr0IYbS__"